import React from 'react';
import { PropTypes } from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actions as LoginActions } from 'redux/domain/User';
import Customer from 'models/Customer';
import { cancelRequest, getCancelTokenSource } from 'api/Helpers';

import LoginForm from '../components/LoginForm';

/**
 * Allow the user to Log into eSTORIS.
 */
class LoginContainer extends React.Component {
	constructor() {
		super();

		this.cancelTokenSource = getCancelTokenSource();
		this.switchModal = this.switchModal.bind(this);
	}

	componentWillReceiveProps(nextProps) {
		if (!nextProps.customer.isGuest) {
			// Customer has sucessfully logged in. Close the form.
			this.props.closeLogin();
		}
	}

	componentWillUnmount() {
		// if a request is in progress stop it.
		cancelRequest(this.cancelTokenSource);
	}

	/**
	 * Open the registration screen instead.
	 */
	switchModal() {
		this.props.closeLogin();
		this.props.openRegistration();
	}

	render() {
		const { isLoggingIn, loginUser } = this.props;
		return (
			<LoginForm
				cancelToken={this.cancelTokenSource.token}
				isLoggingIn={isLoggingIn}
				login={loginUser}
				switchModal={this.switchModal}
			/>
		);
	}
}

LoginContainer.propTypes = {
	closeLogin: PropTypes.func.isRequired,
	customer: PropTypes.instanceOf(Customer).isRequired,
	isLoggingIn: PropTypes.bool.isRequired,
	loginUser: PropTypes.func.isRequired,
	openRegistration: PropTypes.func.isRequired,
};

const mapStateToProps = state => {
	const customer = state.user.get('customer');
	const isLoggingIn = state.user.get('isLoggingIn');
	return {
		customer,
		isLoggingIn,
	};
};

const mapDispatchToProps = dispatch => bindActionCreators(LoginActions, dispatch);

// for testing purposes
export { LoginContainer as LoginContainerClass };

// connect returns a function that accepts a component
export default connect(mapStateToProps, mapDispatchToProps)(LoginContainer);
